import React, { useEffect, useState,useRef} from "react";
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from "react-redux";
import { SetComponentId } from "../../redux/counterSlice";
import ScrollContainer from "react-indiana-drag-scroll";
import checkSvg from "../../assets/images/check.svg";
import crossSvg from "../../assets/images/uncheck.svg";
import API from "../../services/api";
import { SlIcon, SlInput } from "@shoelace-style/shoelace/dist/react";
import BirdViewData from "./BirdViewData";
import mikeSvg from "../../assets/images/campaign.svg";
import pieChart from "../../assets/images/pieChart.svg";
import { formatDate, formatFullDate, formatDateWithTime } from "../../utils/dateFormat";
import Carousel from "react-bootstrap/Carousel";
import Datepicker from "react-tailwindcss-datepicker";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { CarouselItem, Table } from "react-bootstrap";
import {SlTabGroup, SlTab } from "@shoelace-style/shoelace/dist/react";
import DashBoardStats from "./DashBoardStats";
import { debounce } from "../../utils/Debounce";
import { BrandsTypes,  roles } from "../../utils/constants";
import SlSwitch from '@shoelace-style/shoelace/dist/react/switch';
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export const getStartOfMonth = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};
function SalesDashBoard() {
  const dispatch = useDispatch();
  dispatch(SetComponentId(39));
  const [isDateWise,setisDateWise]=useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [brand, setBrand] = useState();
  const [salePersonId, setSalesPersonId] = useState(-1);
  const [data, setData] = useState([{}]);
  const [remainders, setRemainders] = useState(null);
  const [comaparisonData, setComparisonData] = useState([]);
  const [search, setSearch] = useState("");
  const [events, setEvents] = useState({events: [], remainders: []});
  const [date, setDate] = useState({
    startDate: getStartOfMonth(),
    endDate: new Date(),
  });
  const [newsPaperData, setNewsPaperData] = useState([]);
  const [dashboard, setDashboard] = useState(true);
  const [new_user_type, setNew_user_type] = useState(null)
  const [revenuePerctData, setRevenuePerctData] = useState(null)
  const [csvData, setCsvData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date())
  const [initialRender, setInitialRender] = useState(true)
  const csvLinkRef = useRef();

  const handleValueChange = (newValue) => {
    setDate(newValue);
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  function formatAmount(amt, amt1) {
    amt = parseFloat(amt);
    amt1 = parseFloat(amt1);
    let amount = amt + amt1;
    amount = amount / 100000;
    amount = amount.toFixed(2);

    return `${amount} L`;
  }

  function formatSpentValue(value) {
    if (value < 1000) {
      return `${value}`;
    } else if (value >= 1000 && value < 100000) {
      const kValue = (value / 1000).toFixed(2);
      return `${kValue}K`;
    } else if (value >= 100000 && value < 10000000) {
      const lValue = (value / 100000).toFixed(2);
      return `${lValue}L`;
    } else if (value >= 10000000) {
      const crValue = (value / 10000000).toFixed(2);
      return `${crValue}Cr`;
    } else {
      return 0;
    }
  }
  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_dashboard/dashboardBrands",
        method: "POST",
        responseType: "json",
        data: {
          date: date,
          search: search,
        },
      });
      if (res.code === 200) {
        setData(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  const fetchComaprisonData = async () => {
    try {
      let res = await API({
        url: "/sales_dashboard/monthlyStats",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setComparisonData((prevData) => [
          {
            ...prevData[0],
            accounts: +res?.data?.thisMonthAccounts || 0,
            soft: +res?.data?.thisMonthSoftInteractions || 0,
            hard: +res?.data?.thisMonthHardInteractions || 0,
            campaigns: +res?.data?.thisMonthCampaigns || 0,
            known: +res?.data?.thisMonthknownCampaigns || 0,
            unknown: +res?.data?.thisMonthunknownCampaigns || 0,
            marketShare: +res?.data?.thisMonthMarketShare || 0,
            sales: +res?.data?.thisMonthSales || 0,
            target: +res?.data?.thisMonthTarget || 0,
            aov: +res?.data?.thisMonthAOV || 0,
            freq: +res?.data?.thisMonthHardIntFreq || 0,
            coverage: +res?.data?.thisMonthHardIntCover || 0,
          },
          {
            ...prevData[1],
            accounts: +res?.data?.lastMonthAccounts || 0,
            soft: +res?.data?.lastMonthSoftInteractions || 0,
            hard: +res?.data?.lastMonthHardInteractions || 0,
            campaigns: +res?.data?.lastMonthCampaigns || 0,
            known: +res?.data?.lastMonthknownCampaigns || 0,
            unknown: +res?.data?.lastMonthunknownCampaigns || 0,
            marketShare: +res?.data?.lastMonthMarketShare || 0,
            sales: +res?.data?.lastMonthSales || 0,
            target: +res?.data?.lastMonthTarget || 0,
            aov: +res?.data?.lastMonthAOV || 0,
            freq: +res?.data?.lastMonthHardIntFreq || 0,
            coverage: +res?.data?.lastMonthHardIntCover || 0,
          },
          ...prevData.slice(2),
        ]);
        setNew_user_type(res.data?.new_user_type || 1)
      }
    } catch (error) {
      console.error(error);
    }
  };


  function formatDateRange(startDate, endDate) {
    // Parse the input dates
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    // Get month and day for start and end dates
    const startMonth = start.toLocaleString('default', { month: 'short' });
    const endMonth = end.toLocaleString('default', { month: 'short' });
    const startDay = start.getDate();
    const endDay = end.getDate();
    
    // Format the date range
    const formattedRange = `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${end.getFullYear()}`;
    
    return formattedRange;
}

const fetchNewsPapers = async() =>{
  try {
    let res = await API({
      url: "/market/newspapers",
      method: "POST",
      responseType:'json',
      data:{}
    })
    if(res.code === 200){
      setNewsPaperData([...res.data])
    }
  } catch (error) {
    console.error(error)
  }
}
  const fetchRemainders = async () => {
    try {
      let res = await API({
        url: "/accountManagement/getRemainders",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setRemainders(res.data?.remainders);
        setEvents(res.data?.events);
      }
    } catch (error) {
      console.error(error);
    }
  };
 const handleDateWise = async (month)=>{
   try{
      let res=await API({
        url:"/sales_dashboard/revenue-percentagesDateWise",
        method: "POST",
        responseType: "json",
        data: {month}
      })
      if(res.code === 200){
        setRevenuePerctData({month, data: res.data})
      }
   }catch(error){
      console.error(error);
   }
 }

 const handleToggle = (e) => {
  const newValue = e.target.checked;
  setisDateWise(newValue);

  if (newValue) {
   handleDateWise(selectedMonth)
  } else {
      fetchRevenuePercentages(selectedMonth);
  }
};

const csvHeaders = [
  { label: "Date", key: "Date" },
  { label: "adPartner", key: "adPartner" },
  { label: "MainUser", key: "MainUser" },
  ...BrandsTypes.map(brand => ({
    label: brand.label,
    key: String(brand.value) 
  })),
  { label: "Total", key: "Total" }
];

const handleMonthChange = (date) => {
  setisDateWise(false)
  setSelectedMonth(date);
};


const generateCSVData = () => {
  const result = revenuePerctData?.data?.result || [];
  const data = [
    ...result.map((row) => {
      const adPartner = Number(row?.data?.adPartner || 0);
      const mainUser = Number(row?.data?.["-1"] || 0);

      const brandValues = BrandsTypes.reduce((acc, brand) => {
        acc[brand.value] = Number(row.data?.[brand.value] || 0);
        return acc;
      }, {});

      const Total =
        parseInt(adPartner) +
        parseInt(mainUser) +
        Object.values(brandValues).reduce((sum, v) => sum + parseInt(v), 0);

      return {
        Date: new Date(Number(row.date) * 1000).toLocaleDateString(),
        adPartner,
        MainUser: mainUser,
        ...brandValues,
        Total
      };
    }),
   {
      Date: "Total",
      adPartner: revenuePerctData?.data?.totals["adPartner"] || 0,
      MainUser: revenuePerctData?.data?.totals["-1"] || 0,
      ...BrandsTypes.reduce((acc, brand) => {
        acc[brand.value] = revenuePerctData?.data?.totals[brand.value] || 0;
        return acc;
      }, {}),
      Total:(revenuePerctData?.data?.totals["adPartner"] || 0) + (revenuePerctData?.data?.totals["-1"] || 0) + (BrandsTypes.reduce((acc, brand)=> acc + revenuePerctData?.data?.totals[brand.value] || 0 ,0 ))
    }
  ];
  setCsvData(data);
};

  const getLogo = (brand) =>{
    const brandLookup = newsPaperData.filter(np => np.name === brand)
    return brandLookup?.[0]?.logo
  }
  useEffect(()=>{
    fetchComaprisonData();
    fetchRemainders();
  },[])

  useEffect(()=>{
    fetchNewsPapers();
  },[])
  function navigateToNewTab() {
    const url = '/home/help'; // The relative path to the new page
    const fullUrl = window.location.origin + url; // Construct the full URL
    window.open(fullUrl, '_blank');
  }
  useEffect(() => {
    if(date.startDate !== null && date.endDate!== null && dashboard){
      fetchData();
    }
  }, [date,dashboard, search]);

  const fetchRevenuePercentages = async(month) => {
    try {
        let result = await API({
          url: "/sales_dashboard/revenue-percentages",
          method: "POST",
          responseType: "json",
          data: {
            month: month 
          }
        })
        if(result.code === 200){
          setRevenuePerctData({month, data: result.data})
        }
    } catch (error) {
      console.error("Error @ fetchRevenuePercentages", error)
    }
  }
  
  useEffect(() => {
    if (csvData.length > 0) {
        csvLinkRef.current?.link?.click();
    }
  }, [csvData]);
  
  useEffect(()=>{
    if(!initialRender)
      fetchRevenuePercentages(selectedMonth)
    else
      setInitialRender(false)
  },[selectedMonth])


  return (
    <div className='sales_dashboard'>
      <h5>Dashboard</h5>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-[#4952FA1A]">
              <th></th>
              <th>Accounts</th>
              {/* <th>Soft Avg Int</th> */}
              <th>Hard Int %</th>
              <th>Campaigns</th>
              <th>Known</th>
              <th>Unknown</th>
              <th>Market Share</th>
              <th>Sales</th>
              <th>Target %</th>
              {/* <th>AOV</th> */}
              <th>Coverage % </th>
              <th>Frequency</th>
            </tr>
          </thead>
          <tbody>
            <tr key={"month"}>
              <td className="font-semibold">This Month</td>
              <td>{comaparisonData[0]?.accounts}</td>
              {/* <td className="font-semibold">
                <span
                  className={
                    comaparisonData[0]?.soft < comaparisonData[1]?.soft
                      ? "text-red-600"
                      : "text-green-600"
                  }
                >
                  {comaparisonData[0]?.soft ? comaparisonData[0]?.soft.toFixed(2) : 0}%
                </span>
              </td> */}
              <td className="font-semibold">
                <span
                  className={
                    comaparisonData[0]?.hard < comaparisonData[1]?.hard
                      ? "text-red-600"
                      : "text-green-600"
                  }
                  title={comaparisonData[0]?.hard}
                >
                  {comaparisonData[0]?.hard ? comaparisonData[0]?.hard.toFixed(2) : 0}%
                </span>
              </td>
              <td>
                <div className="d-flex gap-2">
                  <img src={mikeSvg} alt="mike"></img>
                  <span >
                    {comaparisonData[0]?.campaigns}
                  </span>
                </div>
              </td>
              <td>{comaparisonData[0]?.known}</td>
              <td>{comaparisonData[0]?.unknown}</td>
              <td>
                <div className="d-flex gap-1">
                  <img src={pieChart} alt="mike"></img>
                  <span
                    className={
                      comaparisonData[0]?.marketShare <
                      comaparisonData[1]?.marketShare
                        ? "redSpend px-1 py-1"
                        : "greenSpend px-1 py-1"
                    }
                    title={comaparisonData[0]?.marketShare}
                  >
                    {comaparisonData[0]?.marketShare.toFixed(2)}%
                  </span>
                </div>
              </td>
              <td className="font-semibold text-blue-600" title={comaparisonData[0]?.sales} onClick={(e) => {
                if (new_user_type === -1) {
                  const startOfThisMonth = new Date();
                  startOfThisMonth.setDate(1);
                  startOfThisMonth.setHours(0, 0, 0, 0);
                  setSelectedMonth(startOfThisMonth)
                }
              }}>
                  {formatSpentValue(comaparisonData[0]?.sales)}
              </td>
              <td>
                <span
                  className={
                    comaparisonData[0]?.target < comaparisonData[1]?.target
                      ? "redSpend px-1 py-1"
                      : "greenSpend px-1 py-1"
                  }
                  title={comaparisonData[0]?.target}
                >
                  {comaparisonData[0]?.target?.toFixed(2)}%
                </span>
              </td>
              {/* <td className="font-semibold">
                <span
                  className={
                    comaparisonData[0]?.aov < comaparisonData[1]?.aov
                      ? "text-red-600"
                      : "text-green-600"
                  }
                >
                  {formatSpentValue(comaparisonData[0]?.aov)}
                </span>
              </td> */}
              <td>
                <span
                  className={
                    comaparisonData[0]?.coverage < comaparisonData[1]?.coverage
                      ? "redSpend px-1 py-1"
                      : "greenSpend px-1 py-1"
                  }
                  title={comaparisonData[0]?.coverage}
                >
                  {comaparisonData[0]?.coverage?.toFixed(2)}%
                </span>
              </td>
              <td>
                <span
                  className={
                    comaparisonData[0]?.freq < comaparisonData[1]?.freq
                      ? "redSpend px-1 py-1"
                      : "greenSpend px-1 py-1"
                  }
                  title={comaparisonData[0]?.freq}
                >
                  {comaparisonData[0]?.freq?.toFixed(2)}
                </span>
              </td>
            </tr>
            <tr key={"last"}>
              <td className="font-semibold">Last Month</td>
              <td>{comaparisonData[1]?.accounts}</td>
              {/* <td className="font-semibold">
                <span
                  className={
                    comaparisonData[0]?.soft > comaparisonData[1]?.soft
                      ? "text-red-600"
                      : "text-green-600"
                  }
                >
                  {comaparisonData[1]?.soft.toFixed(2)}%
                </span>
              </td> */}
              <td className="font-semibold">
                <span
                  className={
                    comaparisonData[0]?.hard > comaparisonData[1]?.hard
                      ? "text-red-600"
                      : "text-green-600"
                  }
                  title={comaparisonData[1]?.hard}
                >
                  {comaparisonData[1]?.hard.toFixed(2)}%
                </span>
              </td>
              <td>
                <div className="d-flex gap-2">
                  <img src={mikeSvg} alt="mike"></img>
                  <span>
                    {comaparisonData[1]?.campaigns}
                  </span>
                </div>
              </td>
              <td>{comaparisonData[1]?.known}</td>
              <td>{comaparisonData[1]?.unknown}</td>
              <td>
                <div className="d-flex gap-1">
                  <img src={pieChart} alt="mike"></img>
                  <span
                    className={
                      comaparisonData[0]?.marketShare >
                      comaparisonData[1]?.marketShare
                        ? "redSpend px-1 py-1"
                        : "greenSpend px-1 py-1"
                    }
                    title={comaparisonData[1]?.marketShare}
                  >
                    {comaparisonData[1]?.marketShare.toFixed(2)}%
                  </span>
                </div>
              </td>
              <td className="font-semibold text-blue-600" title={comaparisonData[1]?.sales} onClick={(e) => { // <== missing (e) here
                  if (new_user_type === -1) {
                    const startOfLastMonth = new Date();
                    startOfLastMonth.setMonth(startOfLastMonth.getMonth() - 1);
                    startOfLastMonth.setDate(1);
                    startOfLastMonth.setHours(0, 0, 0, 0);
                    setSelectedMonth(startOfLastMonth)
                  }
                }}>
                {formatSpentValue(comaparisonData[1]?.sales)}
              </td>
              <td>
                <span
                  className={
                    comaparisonData[0]?.target > comaparisonData[1]?.target
                      ? "redSpend px-1 py-1"
                      : "greenSpend px-1 py-1"
                  }
                  title={comaparisonData[1]?.target}
                >
                  {comaparisonData[1]?.target?.toFixed(2)}%
                </span>
              </td>
              {/* <td className="font-semibold">
                <span
                  className={
                    comaparisonData[0]?.aov > comaparisonData[1]?.hard
                      ? "text-red-600"
                      : "text-green-600"
                  }
                >
                  {formatSpentValue(comaparisonData[1]?.aov)}
                </span>
              </td> */}
               <td>
                <span
                  className={
                    comaparisonData[0]?.coverage > comaparisonData[1]?.coverage
                      ? "redSpend px-1 py-1"
                      : "greenSpend px-1 py-1"
                  }
                  title={comaparisonData[1]?.coverage}
                >
                  {comaparisonData[1]?.coverage?.toFixed(2)}%
                </span>
              </td>
              <td>
                <span
                  className={
                    comaparisonData[0]?.freq > comaparisonData[1]?.freq
                      ? "redSpend px-1 py-1"
                      : "greenSpend px-1 py-1"
                  }
                  title={comaparisonData[1]?.freq}
                >
                  {comaparisonData[1]?.freq?.toFixed(2)}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ScrollContainer>
      <div className="bg-[#D9D9D9] remainder-height w-full flex items-center gap-3 px-3">
        <h5>Reminder</h5>
        <Carousel indicators={false} 
            >
          {remainders?.map((item, index) => (
            <CarouselItem  key={item.date}>
              <div className="d-flex gap-3 flex-wrap">
                <p className="my-0">{formatDateWithTime(item.date)}</p>
                <p className="my-0">{item.description}</p>
              </div>
            </CarouselItem>
          ))}
          {events?.length > 0 ?  events?.map((item, index) => (
             <CarouselItem key={item.date}>
              <div className="d-flex gap-3 flex-wrap">
                <p className="my-0">{item.name}{" - "}{item.event_name}</p>
                <p className="my-0">{formatDate(item.event_date)}</p>
                <p className="my-0">{item.description}</p>
              </div>
            </CarouselItem>
          )) : null}
        </Carousel>
      </div>
      <SlTabGroup>
       
       <SlTab
         onClick={() => {
           setDashboard(true);
         }}
         slot="nav"
         panel="general"
       >
         Dashboard
       </SlTab>
        <SlTab
         onClick={() => {
          setDashboard(false);
         }}
         slot="nav"
         panel="all"
       >
        Stats
       </SlTab> 
   </SlTabGroup>
      {dashboard ?<>
      <div className="d-flex justify-end my-2 ml-auto gap-2  z-10">
        <SlInput size="medium" type="text" placeholder="Brand Name" onSlInput={debounce(handleSearch, 1000)} />
        <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-96">
          <Datepicker
            classNames="form-input"
            popoverDirection="down"
            value={date}
            readOnly
            primaryColor={"cyan"}
            showShortcuts={true}
            // useRange={false}
            configs={{
              shortcuts: {
                today: "today",
                yesterday: "yesterday",
                currentMonth: "currentMonth",
                pastMonth: "lastMonth",
              },
            }}
            onChange={handleValueChange}
          />
        </div>
      </div>
      <div className="mt-2 overall">
        <ScrollContainer>
        <table className="table table-bordered">
  <thead className="bg-[#F3F3F3] sticky top-0 z-10">
    <tr>
      <th className="sticky left-0 bg-[#817f7f] z-9">Client</th>
      <th>Time Period</th>
      <th>Spent</th>
      <th>Platform</th>
      <th>Way2news</th>
      <th>Known</th>
      <th>Unknown</th>
    </tr>
  </thead>
  {data?.length && !loader ? (
    <tbody>
      {data.map((item, index) => {
        return (
          <>
            <tr>
              <td className="capitalize font-semibold w-[9rem] sticky left-0 bg-white z-9">
                <div className="truncate">{item.brand_name}</div>
              </td>
              <td className="font-semibold w-[10rem]">{formatDateRange(date.startDate, date.endDate)}</td>
              <td>
                <span className="bg-[#E5EBFF] text-[#0038FF] px-2 py-2 rounded">
                  {formatAmount(item?.total_campaigns_spent, item?.total_w2n_spent)}
                </span>
              </td>
              <td>
                <div className="d-flex gap-2 min-w-[6rem] flex-wrap">
                  {item?.combined_targets?.map((item, index) => (
                    <img className="w-6" src={getLogo(item)} alt="logo" key={index}></img>
                  ))}
                  {item?.total_w2n_count !== "0" ? <img src={getLogo('Way2news')} alt="notexist"></img> : null}
                </div>
              </td>
              <td>
                <img src={item?.total_w2n_count !== "0" ? checkSvg : crossSvg} alt="exist"></img>
              </td>
              <td className="font-semibold">{item.total_known}</td>
              <td className="font-semibold">
                {item.total_unknown}
                <div className="justify-end d-flex ml-auto">
                  {selectedIndex === index ? (
                    <SlIcon
                      library="lucide"
                      className="cursor-pointer"
                      name={"chevron-up"}
                      onClick={() => setSelectedIndex(-1)}
                    ></SlIcon>
                  ) : (
                    <SlIcon
                      library="lucide"
                      className="cursor-pointer"
                      name={"chevron-down"}
                      onClick={() => {
                        setSelectedIndex(index);
                        setBrand(item?.brand_id);
                        setSalesPersonId(item?.sales_person_id);
                      }}
                    ></SlIcon>
                  )}
                </div>
              </td>
            </tr>
            {selectedIndex === index ? (
              <tr>
                <td colSpan={7}>
                  <div>
                  <BirdViewData brand={brand} salesPerson_id={salePersonId} date={date}  fetchW2n={true} fetchAllNews={true}/>
                 {localStorage.getItem('role') === roles.salesperson && <div slot="footer" className='flex !items-center justify-end text-xs'><span>Report an</span><button className='btn btn-link !text-xs' onClick={navigateToNewTab}>issue/Misrepresentation</button></div>}

                  </div>
                </td>
              </tr>
            ) : null}
          </>
        );
      })}
    </tbody>
  ) : !data?.length && !loader ? (
    <NoDataFound colspan="7" />
  ) : (
    <TableLoader colspan="7" />
  )}
</table>

        </ScrollContainer>
      </div>
      </> : <DashBoardStats />}

 <Modal show={revenuePerctData} onHide={() => {setisDateWise(false);setRevenuePerctData(null)}} dialogClassName="dash-modal-width">
  <Modal.Header closeButton>
  <div className="w-full flex items-center justify-evenly">
      <Modal.Title>
        Month:{formatFullDate(selectedMonth)}
      </Modal.Title>
      <SlSwitch checked={isDateWise} onSlChange={(e) => handleToggle(e)}>
        Date Wise
      </SlSwitch>
      <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Select Month</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser border border-gray-300 rounded-md px-2 py-1 text-sm"
            />
          </div>

      {csvData.length > 0 && (
       <CSVLink
          data={csvData}
          headers={csvHeaders}
          filename="salesDaywisereport.csv"
          ref={csvLinkRef}
          style={{ display: 'none' }}
       />
      )}

      { isDateWise && 
                <sl-tooltip content="Download" placement="top">
                      <SlIcon library="lucide" name="download" onClick={generateCSVData}/>
                </sl-tooltip>
      }
  </div>
  </Modal.Header>
  <Modal.Body>

    {(isDateWise===false) ? (
      <div>
      <div className="sales_dashboard-perc-cards grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-4">
      {revenuePerctData?.data?.length && revenuePerctData?.data?.map((percitem, index) => (
        <div
          key={index}
          className="rounded-2xl p-4 shadow-lg border border-gray-200 bg-gradient-to-br from-blue-50 to-white transition-all flex flex-col justify-between hover:shadow-xl"
        >
          <div className="text-left mb-2">
            <div className="text-xs text-gray-500 uppercase tracking-wide">Team</div>
            <div className="text-lg font-bold text-blue-700">
              {percitem.new_user_type === -1 ? 'Main User' : percitem.new_user_type === 6 ? 'Ad Partners + Network Ads' : BrandsTypes.find(item => item.value === percitem.new_user_type)?.label || "Unknown"}
            </div>
          </div>
          <div className="text-left mt-2">
            <div className="text-xs text-gray-500 uppercase tracking-wide">Revenue</div>
            <div className="text-lg font-semibold text-green-600 flex items-center gap-2" title={percitem.spent}>
              ₹{formatSpentValue(percitem.spent)}
              <span className="inline-block bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded-full">
                {(percitem.percent || 0).toFixed(2)}%
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
    <hr></hr>
    <h5 className="text-center text-blue-700">Total Spent: <span className="text-green-700">₹{revenuePerctData?.data?.length && formatSpentValue(revenuePerctData?.data?.reduce((acc, percitem)=> acc + +percitem.spent, 0 ))} </span></h5>
    </div>
  ) : (<Table className='table table-bordered'>
            <thead>
                <tr>
                <th>Date</th>
                <th>AdPartner</th>
                <th>MainUser</th>
                {BrandsTypes.map(brand => (
                <th key={brand.value}>{brand.label}</th>
                ))}
                <th>Total</th>
                </tr>
            </thead>
            <tbody>
            {revenuePerctData?.data?.result?.length && revenuePerctData?.data?.result?.map((row,index)=>{
                 return(
                   <tr>
                      <td>{new Date(Number(row?.date) * 1000).toLocaleDateString()}</td>
                      <td title={row?.data?.adPartner || 0}>{formatSpentValue(row?.data?.adPartner || 0)}</td>
                      <td title={row?.data?.['-1'] || 0}>{formatSpentValue(row?.data?.['-1'] || 0)}</td> 
                      {BrandsTypes.map(brand => (
                      <td title={row.data?.[brand.value] || 0} key={brand.value}>{formatSpentValue(row.data?.[brand.value] || 0)}</td>
                     ))}
                   <td title={Number((
                          Number(row?.data?.adPartner || 0) +
                          Number(row?.data?.['-1'] || 0) +
                          BrandsTypes.reduce((sum, brand) => sum + Number(row.data?.[brand.value] || 0), 0)
                        ))}>
                      {
                        formatSpentValue(Number((
                          Number(row?.data?.adPartner || 0) +
                          Number(row?.data?.['-1'] || 0) +
                          BrandsTypes.reduce((sum, brand) => sum + Number(row.data?.[brand.value] || 0), 0)
                        )))
                      }
                    </td>

                   </tr>
                 )
            })}
            {revenuePerctData?.data?.totals && <tr className="font-bold bg-gray-100">
                <td>Total</td>
                <td title={revenuePerctData?.data?.totals["adPartner"] || 0}>{formatSpentValue(revenuePerctData?.data?.totals["adPartner"] || 0)}</td>
                <td title={revenuePerctData?.data?.totals["-1"] || 0}>{formatSpentValue(revenuePerctData?.data?.totals["-1"] || 0)}</td>
                {BrandsTypes.map(brand => (
                  <td title={revenuePerctData?.data?.totals[brand.value] || 0} key={brand.value}>{formatSpentValue(revenuePerctData?.data?.totals[brand.value] || 0)}</td>
                ))}
                <td title={(revenuePerctData?.data?.totals["adPartner"] || 0) + (revenuePerctData?.data?.totals["-1"] || 0) + (BrandsTypes.reduce((acc, brand)=> acc + revenuePerctData?.data?.totals[brand.value] || 0 ,0 ))}>{formatSpentValue((+revenuePerctData?.data?.totals["adPartner"] || 0) + (+revenuePerctData?.data?.totals["-1"] || 0) + (BrandsTypes.reduce((acc, brand)=> acc + +revenuePerctData?.data?.totals[brand.value] || 0 ,0 ))) }</td>
          </tr>}
            </tbody>
           </Table>)}

  </Modal.Body>
</Modal>
</div>
  );
}

export default SalesDashBoard;
